import styled from "styled-components";

import { colors, typography } from "src/assets/styles/settings";

export const StyledDelayLabel = styled("label")<{ color: "banana" | "sakura"; isMaintenance: boolean }>`
  white-space: nowrap;
  padding: 2px 6px;
  border-radius: 8px;
  font-weight: 500;
  font-size: ${typography.font_size.small};
  line-height: 1;

  ${({ color, isMaintenance }) => {
    if (isMaintenance) {
      return `
        background-color: ${colors.light_smoke};
        color: ${colors.dark_grey};
      `;
    }

    if (color === "banana") {
      return `
        background-color: ${colors[color]};
        color: ${colors.goldenrod};
      `;
    }

    return `
        background-color: ${colors[color]};
        color: ${colors.clown_red};
      `;
  }};
`;
